import BaseService from '_services/rest/base';

class RegionService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/region`;
  }

  getUrlSave(id, url = '/') {
    if (id) {
      return {
        url: `${this.getUrl()}/${url}${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${url}`,
      method: 'POST',
    };
  }

  getRegionById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const withCount = params.withCount === null ? null : 'resellers';
    const filters = {
      search: params.search,
      state: params.state,
      withCount,
    };

    return this.request(
      `${this.getUrl()}/all/${params.skip}/${params.take}`,
      filters
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(region) {
    const meta = this.getUrlSave(region.id, '');
    return this.request(meta.url, region, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  delete(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE').catch(err => {
      throw err;
    });
  }

  getRegionDistributors(params) {
    const filters = { search: params.search, group: params.group };
    return this.request(
      `${this.getUrl()}/resellers/${params.id}/${params.skip}/${
        params.take
      }`,
      filters
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  syncResellers({ id, resellers }) {
    return this.request(
      `${this.getUrl()}/resellers/${id}`,
      { resellers },
      'PUT'
    ).catch(err => {
      throw err;
    });
  }
}

export default new RegionService();
